import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { requestAPIActions } from 'loopback-react-request';

import '../TroughAdd/TroughAdd.scss';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface TroughQtyRemoveProps {
  configuration: GlobalPrivateState['configuration'];
  dispatch: Function;
  troughId: string;
  warning: GlobalPrivateState['warning'];
}

export class TroughQtyRemovePartial extends React.Component<TroughQtyRemoveProps> {
  
  constructor(props: TroughQtyRemoveProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  
  public render() {
    const { warning } = this.props;
    return this.quantity ? (
      <div className="partial-trough-remove">
        <button
          className="trough-icon trough-icon-remove"
          onClick={this.handleClick}
          disabled={this.disabled || warning.requireReset.qty.required || (this.quantity && this.quantity === 1) ? true : false}
        >
          <span className="remove" />
        </button>
      </div>
    ) : null;
  }

  private get quantity(): number | null | undefined {
    const { configuration } = this.props;
    return configuration && 
      configuration.result && 
      configuration.result.selectedTrough && 
      configuration.result.selectedTrough.qty;
  }

  private get configurationId(): string | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result && configuration.result.id;
  }

  private get disabled(): boolean {
    return !isConfigurationEditable();
  }
  
  private handleClick(event: React.MouseEvent) {
    const { troughId } = this.props;
    if (!this.quantity || this.disabled) {
      return;
    }
    const qty = this.quantity - 1;
    if (this.configurationId && qty >= 1 && qty !== this.quantity) {
      this.props.dispatch(requestAPIActions.load(
        'configuration',
        { 
          url: `/Configurations/${this.configurationId}`,
          options: {
            method: 'PATCH',
            data: {
              troughId: troughId,
              selectedTrough: {
                qty: qty,
              },
            }
          },
        },
        true
      ));
    }    
  }
}

export const TroughQtyRemove = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  warning: state.warning,
}))(TroughQtyRemovePartial);

export default TroughQtyRemove;
